import { Component, OnInit } from '@angular/core';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
  standalone: false
})
export class ProfileImageComponent implements OnInit {
  public uploader: FileUploader = new FileUploader({
    // allowedFileType: ["image"],
    url:''
  });

  constructor() {
  }
  ngOnInit() {
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map(fileItem => {
    
      return fileItem.file;
    });
  }

  reorderFiles(reorderEvent: CustomEvent) {
    let element = this.uploader.queue.splice(reorderEvent.detail.from, 1)[0];
    this.uploader.queue.splice(reorderEvent.detail.to, 0, element);
  }
}


